<template>
    <div>
        <el-dialog
            title="项目详情"
            :visible.sync="showDialog"
            width="1200px"
            @close="close">

            <div class="base-warp">
                <el-row class="project-detail">
                    <el-col class="project" :span="18" :offset="0">
                        <el-row class="head">
                            <el-col :span="12" :offset="0">
                                <div class="title">暂存内容</div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="title">线上内容</div>
                            </el-col>
                        </el-row>
                        
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    名称
                                </div>
                                <div class="info">
                                    <span class="span">{{edit.name}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    名称
                                </div>
                                <div class="info">
                                    <span class="span" v-if="project">{{project.name}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    类型
                                </div>
                                <div class="info">
                                    <span class="span">{{edit.type}}</span>
                                    <span class="span" v-if="edit.message">{{edit.message.mold}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    类型
                                </div>
                                <div class="info" v-if="project">
                                    <span class="span">{{project.type}}</span>
                                    <span class="span" v-if="project.message">{{project.message.mold}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    地址
                                </div>
                                <div class="info">
                                    <span class="span" v-if="edit.location">{{edit.location.address}}</span>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    地址
                                </div>
                                <div class="info">
                                    <span class="span" v-if="project">{{project.location.address}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    标签
                                </div>
                                <div class="info">
                                    <div class="tags">
                                        <div class="tag" v-for="(tag, index) in edit.tags" :key="index">{{tag}}</div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    标签
                                </div>
                                <div class="info">
                                    <div class="tags" v-if="project">
                                        <div class="tag" v-for="(tag, index) in project.tags" :key="index">{{tag}}</div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    费用
                                </div>
                                <div class="info" v-if="edit.message">
                                    <p class="p">单价：{{edit.message.price}}元/㎡/月</p>
                                    <p class="p">房租：押{{edit.message.deposit}}付{{edit.message.rent}}</p>
                                    <p class="p">起租期：{{edit.message.startMonth}}个月</p>
                                    <p class="p">免租期：{{edit.message.freeMonth}}个月</p>
                                    <p class="p">物业费：{{edit.message.propertyFee}}元/㎡/月</p>
                                    <p class="p">水费：{{edit.message.waterRate}}元/方</p>
                                    <p class="p">电费：{{edit.message.energyFee}}元/度</p>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    费用
                                </div>
                                <div class="info" v-if="project">
                                    <p class="p">单价：{{project.message.price}}元/㎡/月</p>
                                    <p class="p">房租：押{{project.message.deposit}}付{{project.message.rent}}</p>
                                    <p class="p">起租期：{{project.message.startMonth}}个月</p>
                                    <p class="p">免租期：{{project.message.freeMonth}}个月</p>
                                    <p class="p">物业费：{{project.message.propertyFee}}元/㎡/月</p>
                                    <p class="p">水费：{{project.message.waterRate}}元/方</p>
                                    <p class="p">电费：{{project.message.energyFee}}元/度</p>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    概况
                                </div>
                                <div class="info" v-if="edit.message">
                                    <p class="p">面积：{{edit.message.area}}㎡</p>
                                    <p class="p">楼层：{{edit.message.floorHigh}}·{{edit.message.floor+'层'}}</p>
                                    <p class="p">大小：面宽{{edit.message.width}}m·层高{{edit.message.height}}m·进深{{edit.message.deep}}m</p>
                                    <p class="p">临街：{{edit.message.frontage?'是':'否'}}</p>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    概况
                                </div>
                                <div class="info" v-if="project">
                                    <p class="p">面积：{{project.message.area}}㎡</p>
                                    <p class="p">楼层：{{project.message.floorHigh}}·{{project.message.floor+'层'}}</p>
                                    <p class="p">大小：面宽{{project.message.width}}m·层高{{project.message.height}}m·进深{{project.message.deep}}m</p>
                                    <p class="p">临街：{{project.message.frontage?'是':'否'}}</p>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    配置
                                </div>
                                <div class="info" v-if="edit.mating">
                                    <div class="mating">
                                        <span class="mat span" v-for="(mat, index) in edit.mating" :key="index">{{mat}}</span>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    配置
                                </div>
                                <div class="info">
                                    <div class="mating" v-if="project">
                                        <span class="mat span" v-for="(mat, index) in project.mating" :key="index">{{mat}}</span>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>

                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    介绍
                                </div>
                                <div class="info" v-if="edit.presentation">
                                    <div class="presentation" v-html="edit.presentation"></div>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    介绍
                                </div>
                                <div class="info" v-if="project">
                                    <div class="presentation" v-html="project.presentation"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="prow">
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    图片
                                </div>
                                <div class="info" v-if="edit.imgs">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in edit.imgs" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="edit.imgs"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="0">
                                <div class="label">
                                    图片
                                </div>
                                <div class="info" v-if="project">
                                    <div class="img-warp">
                                        <div class="img-box" v-for="(img, index) in project.imgs" :key="index">
                                            <el-image class="img" :src="img" fit="contain" :lazy="true" :preview-src-list="project.imgs"></el-image>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                        </el-row>
                        
                    </el-col>
                    <el-col class="log" :span="6" :offset="0">
                        <div class="head">
                            <p class="title">记录</p>
                        </div>
                        <div class="timeline">
                            <el-timeline :reverse="reverse" timestamp="2018/4/12" placement="top">
                                <el-timeline-item
                                v-for="(log, index) in logs"
                                :key="index"
                                icon="el-icon-more"
                                type="primary">
                                    <el-card>
                                        <p>{{log.msg}}</p>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <div class="foot">
                        <el-button v-if="project&&project.status=='01'" type="warning" size="default" @click="soltout">下架</el-button>
                        <el-button v-if="edit.status=='02'" type="danger" size="default" @click="shownopass = true">不通过</el-button>
                        <el-button v-if="edit.status=='02'" type="primary" size="default" @click="pass">审核通过</el-button>
                    </div>
                </el-row>
                
            </div>
            <el-dialog
            width="400px"
            title="不通过理由"
            :visible.sync="shownopass"
            append-to-body>
                <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="normal">
                    <el-form-item label="填写理由">
                        <el-input type="textarea" v-model="form.marker"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="nopass">提交不通过</el-button>
                        <el-button @click="shownopass = false">取消</el-button>
                    </el-form-item>
                </el-form>
                
            </el-dialog>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDialog: true,
            id: '',
            edit: '',
            project: '',
            logs: [],
            reverse: true,
            shownopass: false,
            form: {
                marker: '',
            },
            rules: {},
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.getProject();
    },
    methods: {
        soltout() {
            this.$confirm('是否确定下架').then(
                confirm=>{
                    var params = {
                        id: this.id,
                    }
                    this.$api.projectSoltOut(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getProject();
                        }
                    )
                },
                cancel=>{}
            )
            
        },
        nopass() {
            var params = {
                id: this.id,
                marker: this.form.marker,
            }
            this.$api.projectNoPass(params).then(
                data=>{
                    this.message.success(data);
                    this.getProject();
                }
            )
        },
        pass() {
            this.$confirm('是否确定通过审核').then(
                confirm=>{
                    var params = {
                        id: this.id,
                    }
                    this.$api.projectPass(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getProject();
                        }
                    )
                },
                cancel=>{}
            )
        },
        getProject() {
            var params = {
                id: this.id,
            }
            this.$api.getProjectDetail(params).then(
                data=>{
                    console.log(data);
                    let {edit, house, logs} = data;
                    if(edit.location) edit.location = JSON.parse(edit.location);
                    if(edit.tags) edit.tags = JSON.parse(edit.tags);
                    if(edit.message) edit.message = JSON.parse(edit.message);
                    if(edit.mating) edit.mating = JSON.parse(edit.mating);
                    if(edit.imgs) edit.imgs = JSON.parse(edit.imgs);
                    this.edit = edit;
                    if (house){
                        if(house.location) house.location = JSON.parse(house.location);
                        if(house.tags) house.tags = JSON.parse(house.tags);
                        if(house.message) house.message = JSON.parse(house.message);
                        if(house.mating) house.mating = JSON.parse(house.mating);
                        if(house.imgs) house.imgs = JSON.parse(house.imgs);
                    }
                    this.project = house;
                    this.logs = logs;
                }
            )
        },
        close() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>